import React from 'react'
import { ResponsiveLayout } from 'containers'
import Header from 'containers/ResponsiveLayout/Header'
import { AccountWithRollout } from './AccountWithRollout'

export const Account = () => {
  return (
    <ResponsiveLayout
      menu={<Header />}
      content={<AccountWithRollout />}
    />
  )
}
